import React from "react";

import FormElement from "components/FormElement/FormElement";
import Radio from "components/Radio/Radio";
import Row from "components/Row/Row";
import Select from "components/Select/Select";

import styles from "./DashboardViews.module.scss";

const QuestionView = (props) => {
    const { task, setQuestion, question } = props;

    console.log(task);

    const riskDropdownRef = React.createRef();

    const handleChange = (name) => (e) => {
        const value = e.target.value;
        setQuestion((s) => ({
            ...s,
            [name]: value,
        }));
        e.persist();
    }

    return (
        <div className={styles.question}>

            <br />

            <div>
                <span>{task.subtask_data.act_name} / {task.subtask_data.regulation_number}</span>
                <h3>{task.task}</h3>
            </div>

            <FormElement htmlFor="answer">
                <Row className={styles["status-row"]}>
                    {/* 2 = Yes */}
                    <Radio
                        disabled={task.completed === "t" ? true : false}
                        checked={question.answer === "2"}
                        labelText="Yes"
                        onChange={handleChange('answer')}
                        value="2"
                    />
                    {/* 1 = No */}
                    <Radio
                        disabled={task.completed === "t" ? true : false}
                        checked={question.answer === "1"}
                        labelText="No"
                        onChange={handleChange('answer')}
                        value="1"
                    />
                    {/* 3 = Not Applicatble */}
                    <Radio
                        disabled={task.completed === "t" ? true : false}
                        checked={question.answer === "3" || question.answer === "4"}
                        labelText="Not Applicable"
                        onChange={handleChange('answer')}
                        value="3"
                    />
                    {/* 0 = Assign */}
                    {/* <Radio
                        // disabled={disabled}
                        checked={state.answer === "4"}
                        labelText="Assign"
                        onChange={handleChange('answer')}
                        value="4"
                    /> */}
                </Row>
            </FormElement>

            <br />

            <FormElement
                className={styles.risk}
                htmlFor="risk"
                labelText="DEGREE OF RISK"
            >
                <Select
                    labels={{
                        '1': '1 (Minimal risk)',
                        '2': '2',
                        '3': '3',
                        '4': '4 (Average risk)',
                        '5': '5',
                        '6': '6',
                        '7': '7 (High risk)',
                        '8': '8',
                        '9': '9',
                        '10': '10',
                    }}
                    disabled={task.completed === "t" ? true : false}
                    value={question.risk}
                    onClick={handleChange('risk')}
                    dropdownToggleRef={riskDropdownRef}
                >
                    <li value="1">1 (Minimal risk)</li>
                    <li value="2">2</li>
                    <li value="3">3</li>
                    <li value="4">4 (Average risk)</li>
                    <li value="5">5</li>
                    <li value="6">6</li>
                    <li value="7">7 (High risk)</li>
                    <li value="8">8</li>
                    <li value="9">9</li>
                    <li value="10">10</li>
                </Select>
            </FormElement>

            <br />

            <FormElement
                    className={styles.notes}
                    htmlFor="notes"
                    labelText="NOTES"
                >
                    <textarea
                        disabled={task.completed === "t" ? true : false}
                        className={styles.textarea}
                        rows="5"
                        onChange={handleChange('notes')}
                        value={question.notes}
                    />
                </FormElement>

            <br />

        </div>
    );
}

export default QuestionView;
